import React from "react"
import { Link } from "gatsby"

import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../../components/SubPages/IntroSubPages/introSubPages"
import GridView from "../../components/SubPages/GridViewSubPages/gridViewSubPages"
import CurrentSystem from "../../components/SubPages/ServicesPage/ServiceCurrentSystem/serviceCurrentSystem"
import Carousel from "../../components/SubPages/CarouselSubPages/carouselSubPages"
import BlueBar from "../../components/SubPages/SolutionsPage/BlueBar/blueBar"

import VideoIcon from "../../images/solutions/teleMedicine/audiovideo.png"
import ScheduleIcon from "../../images/solutions/teleMedicine/Schedule.png"
import WhiteIcon from "../../images/solutions/teleMedicine/white.png"
import SupportIcon from "../../images/solutions/teleMedicine/Support.png"

import backgroundImg from "../../images/realtime/Telemedicine.svg"

import CarouselImg1 from "../../images/clients/InfinityspyCover.png"

import Constants from "../../constants/solutions.json"

const carouselData = [
  {
    title: "",
    description: Constants.SOLUTIONS.teleMedicine.carouselData.i1.description,
    img: CarouselImg1,
  },
]

const GridData = [
  {
    title: Constants.SOLUTIONS.teleMedicine.GridDataArray.i1.title,
    description: Constants.SOLUTIONS.teleMedicine.GridDataArray.i1.description,
    img: VideoIcon,
  },
  {
    title: Constants.SOLUTIONS.teleMedicine.GridDataArray.i2.title,
    description: Constants.SOLUTIONS.teleMedicine.GridDataArray.i2.description,
    img: ScheduleIcon,
  },
  {
    title: Constants.SOLUTIONS.teleMedicine.GridDataArray.i3.title,
    description: Constants.SOLUTIONS.teleMedicine.GridDataArray.i3.description,
    img: WhiteIcon,
  },
  {
    title: Constants.SOLUTIONS.teleMedicine.GridDataArray.i4.title,
    description: Constants.SOLUTIONS.teleMedicine.GridDataArray.i4.description,
    img: SupportIcon,
  },
]

const TeleMedicine = () => (
  <MainLayout>
    <SEO
      title="TeleMedicine"
      description="The digital transformation of healthcare services looks to make it easier and faster for patients with lower costs. Conducting sessions online not only made it easier for patients without waiting in large queues but also reduced the costs since there is no charge made by the hospital or the medical institute.
            We Develop custom HIPAA compliant telemedicine software for hospitals, clinics and healthcare startups."
      pagePath="/solutions/telemedicine"
      schema={`{
              "@context": "https://meetrix.io/solutions/telemedicine",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.SOLUTIONS.teleMedicine.MainLayout.title}
      description={Constants.SOLUTIONS.teleMedicine.MainLayout.description}
      blueTitle={Constants.SOLUTIONS.teleMedicine.MainLayout.blueTitle}
      blueLink=""
      background={backgroundImg}
    />
    <GridView
      twoCol
      noButton
      title={Constants.SOLUTIONS.teleMedicine.GridView.title}
      description={Constants.SOLUTIONS.teleMedicine.GridView.description}
      bottomTitle={Constants.SOLUTIONS.teleMedicine.GridView.bottomTitle}
      data={GridData}
      linkTitle={Constants.SOLUTIONS.teleMedicine.GridView.linkTitle}
    />
    <BlueBar
      title={Constants.SOLUTIONS.teleMedicine.GridDataArray.i5.title}
      description={
        Constants.SOLUTIONS.teleMedicine.GridDataArray.i5.description
      }
    />
    <Carousel data={carouselData} />
  </MainLayout>
)

export default TeleMedicine
